<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>                    
                    <el-button type="primary" @click="add()" style="width: 96px">新增</el-button>
                </div>
               
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    <el-table-column prop="id" label="ID"></el-table-column>
                    <el-table-column prop="image" label="缩略图">
                     <template slot-scope="scope">
                        <el-popover placement="top-start" trigger="click"> <!--trigger属性值：hover、click、focus 和 manual-->
                        <a :href="formatImage(scope.row.image)" target="_blank" title="查看最大化图片">
                            <img :src="formatImage(scope.row.image)" style="width: 300px;height: 300px">
                        </a>
                        <img slot="reference" :src="formatImage(scope.row.image)" style="width: 80px;height: 80px; cursor:pointer">
                        </el-popover>
                    </template>
                    </el-table-column>                  
                   
                    <el-table-column prop="title" label="标题"></el-table-column>
                    <el-table-column prop="viceTitle" label="关键内容"></el-table-column>
                    <el-table-column prop="content" label="内容" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormat"></el-table-column>
                    
                    <el-table-column label="操作">
                        <template slot-scope="scope">                        
                        <el-button type="text" @click="edit(scope.row)">查看</el-button>
                        <el-button type="text" @click="del(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>                                        
                    
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
    
        </div>
        <el-dialog title="新增新闻资讯" :visible.sync="dialogAddVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="newsAdd" ref="add" size="small" label-width="90px">

                <el-form-item label="标题:" prop="title">
                    <el-input v-model="newsAdd.title" style="width: 320px"></el-input>
                </el-form-item>

                <el-form-item label="副标题:" prop="viceTitle">
                    <el-input v-model="newsAdd.viceTitle" style="width: 320px"></el-input>
                </el-form-item>
                <el-form-item label="发布时间:" prop="releaseTime">
                    <el-input v-model="newsAdd.releaseTime" style="width: 320px"></el-input>
                </el-form-item>
                <el-form-item label="SEO标题:" prop="seoTitle">
                    <el-input v-model="newsAdd.seoTitle" style="width: 320px"></el-input>
                </el-form-item>
                <el-form-item label="SEO关键字:" prop="seoKeyword">
                    <el-input v-model="newsAdd.seoKeyword" style="width: 320px"></el-input>
                </el-form-item>
                <el-form-item label="SEO描述:" prop="seoDescribe">
                    <el-input v-model="newsAdd.seoDescribe" style="width: 320px"></el-input>
                </el-form-item>

                <el-form-item label="文章详情:" prop="content">                   
                    
                    <quill-editor v-model="newsAdd.content" ref="editor" :options="editorOption">
                    </quill-editor>
                </el-form-item>  
               <el-form-item label="图片:" prop="image">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="newsAdd.image"  class="course-img" :src="bannerAdd.image"></el-image>
                            <input type="file" class="upload-input" @change="addImg" accept="image/*" ref="picture"/>
                        </div>      
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑问题" :visible.sync="dialogEditVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form :model="newsEdit"  ref="edit" size="small" label-width="90px">
                <el-form-item label="标题:" prop="title">
                    <el-input v-model="newsEdit.title" style="width: 320px"></el-input>
                </el-form-item>

                <el-form-item label="副标题:" prop="viceTitle">
                    <el-input v-model="newsEdit.viceTitle" style="width: 320px"></el-input>
                </el-form-item>
                <el-form-item label="发布时间:" prop="releaseTime">
                    <el-input v-model="newsEdit.releaseTime" style="width: 320px"></el-input>
                </el-form-item>
                <el-form-item label="SEO标题:" prop="seoTitle">
                    <el-input v-model="newsEdit.seoTitle" style="width: 320px"></el-input>
                </el-form-item>
                <el-form-item label="SEO关键字:" prop="seoKeyword">
                    <el-input v-model="newsEdit.seoKeyword" style="width: 320px"></el-input>
                </el-form-item>
                <el-form-item label="SEO描述:" prop="seoDescribe">
                    <el-input v-model="newsEdit.seoDescribe" style="width: 320px"></el-input>
                </el-form-item>

                <el-form-item label="文章详情:" prop="content">                   
                    <quill-editor v-model="newsEdit.content" ref="editor" :options="editorOption">
                    </quill-editor>
                </el-form-item>   
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>    
    import {
    quillEditor
    } 
    from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    export default {
        components: {
        quillEditor
        },
       
        data() {
            return {
                authorization:localStorage.getItem('authorization'),                
                loading: true,
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                tableData: [],
                dialogAddVisible:false,                
                newsAdd:{
                    title:'',
                    viceTitle:'',
                    releaseTime:'',
                    seoTitle:'',
                    seoKeyword:'',
                    seoDescribe:'',
                    content:'',
                    image:''

                },               
                dialogEditVisible:false,
                newsEdit:{
                    id:'',
                    title:'',
                    viceTitle:'',
                    releaseTime:'',
                    seoTitle:'',
                    seoKeyword:'',
                    seoDescribe:'',
                    content:'',
                    image:''
                },
                editorOption: {},              
                
               
            };
        },
        methods: {
            // 获取科室列表
            getData() {
               this.loading = true                
               let params = {
                    currentPage: this.pageNum,
                    pageSize:this.pageSize                  
                }
                this.axios.post('api-b/10058/100580/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    console.log(res.data)
                    if (res.data.code === 10000) {
                        if (res.data.data.length === 0) {
                            this.$message.info('暂无数据')
                        }
                        this.tableData = res.data.data.list
                        this.total = res.data.data.total                        
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []                        
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    this.total = 0                    
                    this.loading = false
                })
            },
             // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
            formatImage(imageurl) {
                let baseurl = "http://test.zgtyyy.com/chinesemedicine";                 
                return imageurl ? baseurl + imageurl : baseurl + "/src/images/default.png"
                
            },

            cancelAdd() {
                this.dialogAddVisible = false
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                })
            },
            // 新增科室弹窗按钮
            add() {            
                this.dialogAddVisible = true
            },
            uploadImg(data) {
                return new Promise(resolve => {
                    this.axios.post('/api-f/10027/100065',data,{
                        headers:{
                            Authorization: this.authorization,
                            'Content-Type':'multipart/form-data'
                        }
                    }).then(res => {
                        resolve(res)
                    })
                })
            },
        addImg(){
            let inputDOM = this.$refs.picture;
            let file = inputDOM.files[0];
            let params = new FormData()
            params.append('file',file)
            params.append("pathPrefix",'officailInformationContent')
            this.uploadImg(params).then(res => {
                if (res.data.code === 10000) {
                    this.$message.success(res.data.message)
                    this.newsAdd.image = res.data.data.fileUrl
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        confirmAdd(){
            this.$refs.add.validate(valid => {                                            
                let params = {
                    title:this.newsAdd.title,
                    viceTitle:this.newsAdd.viceTitle,
                    releaseTime:this.newsAdd.releaseTime,
                    seoTitle:this.newsAdd.seoTitle,
                    seoKeyword:this.newsAdd.seoKeyword,
                    seoDescribe:this.newsAdd.seoDescribe,
                    content:this.newsAdd.content,
                    image:this.newsAdd.image                   
                                                
                }
                this.axios.post('api-b/10058/100581/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogAddVisible = false
                        this.$message.success(res.data.message)
                        this.getData()                    
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
                
            })

        },
        cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            },
        // 编辑医生弹窗按钮
        edit(data) {
            
            this.axios.get('/api-b/10058/100583/' + data.id,{
            headers:{
                Authorization: this.authorization,
            }
            }).then(res => {
                
                if(res.data.code=== 10000) {
                    if (res.data.data !== null) {
                        this.dialogEditVisible = true
                        this.newsEdit = res.data.data
                        
                    } else {
                        this.$message.info(res.data.message)
                    }
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
            
        confirmEdit() {
            this.$refs.edit.validate(valid => {                
                let params = {
                    id:this.newsEdit.id,
                    title:this.newsEdit.title,
                    viceTitle:this.newsEdit.viceTitle,
                    releaseTime:this.newsEdit.releaseTime,
                    seoTitle:this.newsEdit.seoTitle,
                    seoKeyword:this.newsEdit.seoKeyword,
                    seoDescribe:this.newsEdit.seoDescribe,
                    content:this.newsEdit.content,
                    image:this.newsEdit.image                   
                                                
                }
                this.axios.post('/api-b/10058/100581',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogEditVisible = false
                        this.$message.success(res.data.message)
                        this.getData()
                        this.$nextTick(() => {
                            this.$refs.edit.resetFields()                            
                        })
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

               
            })
        },
       
        del(data){
            const h = this.$createElement;
            this.$msgbox({
                message: h('div',{class:'message-box'}, [
                    h('div', { class: 'message-title-box'}, [
                        h('i', { class:'el-icon-warning message-box-icon' }, ''),
                        h('span', { class:'message-box-title'}, '确认要删除该资讯吗？'),
                    ]),
                    
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {                
                
                this.axios.get('/api-b/10058/100582/' + data.id,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                        this.getData()
                    }
                }).catch(error => {})
            })

        },
        dateFormat:function(row,column){
            
            var date = new Date(row.updateTime);
            
            if(date == undefined){return ''};
            var dateTypeDate = "";
            dateTypeDate += date.getFullYear();   //年
            dateTypeDate += "-" + (date.getMonth()+1); //月
            dateTypeDate += "-" + date.getDate();  //日
            dateTypeDate += ' '
            dateTypeDate += date.getHours();
            dateTypeDate += ":"+date.getMinutes();
            dateTypeDate += ":"+date.getSeconds();
            return dateTypeDate;
        },

           
        },
        watch: {
            
        },
        created() {
            this.getData()                       
        }
    };
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .tag-box {
        width: 288px;
        min-height: 30px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        padding: 0 15px
    }
    .push {
        color:rgba(238,238,238,1);
        font-size: 32px;
        position: absolute;
        top: 30px;
        left: 30px;
    }
    .course-img {
        position: absolute;
        top: 1px;
        width: 92px;
        height: 92px;
    }
     .upload-input {
        opacity: 0;
        width: 92px;
        height: 92px;
        position: absolute;
        top: 0;
    }
</style>